<div>
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field class="input-tg w-6/12" appearance="outline">
      <mat-label>Tipo veículo</mat-label>
      <input
        matInput
        [(ngModel)]="inputSearch"
        (keyup.enter)="search()"
        placeholder="Buscar por descrição"
      />
    </mat-form-field>

    <div class="flex justify-end gap-2 mb-5">
      <button mat-flat-button class="btn-tg-white" (click)="clearSearch()">
        Limpar
      </button>
      <button mat-flat-button class="btn-tg" (click)="search()">
        Pesquisar
      </button>
    </div>
  </div>

  @if (!loading) {
    <div>
      <table-list-select
        [dataSource]="itemsList"
        [columns]="columns"
        [multiSelect]="true"
        [listSelected]="listSelected"
        (selectItem)="selectItem($event)"
      />
    </div>
    <div>
      @if (itemsList.length > 0) {
        <pagination
          [currentPage]="page"
          [pageSize]="rows"
          [totalRecords]="numberRows"
          (pageChanged)="pageChanged($event)"
        />
      }
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <div class="mt-4">
    <h4 class="font-normal">Selecionados ({{ listSelected.length }})</h4>
    @if (listSelected.length > 0) {
      <div class="flex flex-wrap gap-2 mt-2">
        @for (item of listSelected; track item.id) {
          <div class="chip-vehicle-type">
            <span>{{ item.descricao }}</span>
            <button
              class="chip-remove"
              type="button"
              [attr.aria-label]="'Remover ' + item.descricao"
              (click)="removeItem(item)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    } @else {
      <p class="mt-2">Nenhum tipo de veículo selecionado.</p>
    }
  </div>
</div>
